<div class='Home_signup text-center'>
  <div class='Home_signup_wrapper container py-5'>
    <h2><span>Sign up today and watch your sales soar!</span></h2>
    <p>
      Retreva® was created by sales professionals for sales professionals.
      Our goal is to make cold emailing effective by putting the relationship
      back into prospecting.
    </p>
    <a class='Home_signup_wrapper_signbutton' href='/accounts/sign_up'
    >Sign Up</a
    >
  </div>
</div>
